module.exports = __webpack_public_path__ + "img/logo.ca999909.png";